'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');

var environment = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'production'];

module.exports = (0, _assign2.default)({
  host: process.env.HOST || 'localhost',
  port: process.env.PORT || 8080,
  apiHost: process.env.APIHOST || 'http://consignor-server-consignor-go-cgk.service.i.gojek.com/',
  gsmSecretFolder: process.env.GSM_SECRET_FOLDER || 'projects/853398272322/secrets/kilat-ecomm-automation',
  dispatchApiAuth: process.env.DISPATCH_API_AUTH || 'Basic emVuZGVzazpzdXBlcl9zZWNyZXRfcGFzc3dvcmQ=',
  dispatchApiHost: process.env.DISPATCH_API_HOST || 'http://consignor-server-consignor-go-cgk.service.i.gojek.com',
  apiPort: process.env.APIPORT || 8080,
  app: {
    title: 'Kilat e-Commerce Tools',
    description: 'Kilat e-Commerce Tools | API Testing',
    head: {
      titleTemplate: 'Kilat e-Commerce Tools: %s',
      meta: [{ name: 'description', content: 'Kilat e-Commerce Tools | API Testing' }, { charset: 'utf-8' }, { property: 'og:site_name', content: 'Kilat e-Commerce Tools' }, { property: 'og:locale', content: 'en_US' }, { property: 'og:title', content: 'Kilat e-Commerce Tools' }, { property: 'og:description', content: 'Kilat e-Commerce Tools | API Testing' }, { property: 'og:card', content: 'summary' }]
    }
  }

}, environment);


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 245
// module chunks = 0